import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Smartphone, Sparkles, XCircle, CheckCircle2 } from 'lucide-react';
export function ProblemSolutionSection() {
  return <section className="py-12 md:py-16" style={{
    backgroundColor: 'var(--color-off-white)'
  }} data-id="element-175">
      <div className="container mx-auto px-4" data-id="element-176">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-177">
          {/* Problem Block */}
          <FadeIn delay={0.1} data-id="element-178">
            <div className="bg-white rounded-2xl p-8 shadow-sm border h-full" style={{
            borderColor: 'var(--color-border)'
          }} data-id="element-179">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-6" style={{
              backgroundColor: '#FEE2E2'
            }} data-id="element-180">
                <Smartphone className="w-6 h-6 text-red-500" data-id="element-181" />
              </div>
              <h2 className="text-xl md:text-2xl font-bold mb-6" style={{
              color: 'var(--color-deep-blue)'
            }} data-id="element-182">
                El problema que muchos padres enfrentan hoy
              </h2>
              <ul className="space-y-4" data-id="element-183">
                {['Los niños pasan horas frente a pantallas sin contenido de valor', 'Es difícil encontrar recursos cristianos lindos y bien armados', 'Falta tiempo para preparar actividades con propósito', 'Querés enseñarles sobre Dios pero no sabés por dónde empezar'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-184">
                    <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-185" />
                    <span className="text-base font-medium" style={{
                  color: 'var(--color-body)'
                }} data-id="element-186">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Solution Block */}
          <FadeIn delay={0.2} data-id="element-187">
            <div className="bg-white rounded-2xl p-8 shadow-md border-2 h-full relative overflow-hidden" style={{
            borderColor: 'var(--color-gold)'
          }} data-id="element-188">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-[var(--color-cream-warm)] to-transparent opacity-50 rounded-bl-full pointer-events-none" data-id="element-189" />

              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-6 relative z-10" style={{
              backgroundColor: '#FEF6E8'
            }} data-id="element-190">
                <Sparkles className="w-6 h-6" style={{
                color: 'var(--color-gold)'
              }} data-id="element-191" />
              </div>
              <h2 className="text-xl md:text-2xl font-bold mb-6 relative z-10" style={{
              color: 'var(--color-deep-blue)'
            }} data-id="element-192">
                La solución: una colección completa, lista para usar
              </h2>
              <ul className="space-y-4 relative z-10" data-id="element-193">
                {['+500 parábolas con enseñanzas y preguntas para reflexionar', '7 recursos diferentes en un solo pack digital', 'Material diseñado con amor, listo para imprimir o usar en pantalla', 'Ideal para casa, iglesia, escuela dominical o el aula'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-194">
                    <CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                  color: 'var(--color-green)'
                }} data-id="element-195" />
                    <span className="text-base font-bold" style={{
                  color: 'var(--color-deep-blue)'
                }} data-id="element-196">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}